import { takeLatest, put, call, cancelled } from 'redux-saga/effects';

import {
  SET_BUSINESSINFO_TO_DRAFT_START,
} from '../actions';

angular.module('tct.sagas.businessInfo', [])
  .factory('businessInfoSagaFactory', businessInfoSagaFactory);

businessInfoSagaFactory.$inject = [
  'actionsFactory',
  'businessInfoService',
  '$state',
];

function businessInfoSagaFactory(
  actionsFactory,
  businessInfoService,
  $state) {
  const factory = {
    businessInfoFlow,
  };

  return factory;

  function* setBusinessInfoToDraft(action) {
    try {
      const response = yield call(
        businessInfoService.setBusinessInfoToDraft,
        action.businessInfoId);

      yield put(
        actionsFactory.setBusinessInfoToDraftSuccess({ response }));

      $state.reload();

      return response;
    } catch (err) {
      yield put(actionsFactory.setBusinessInfoToDraftError(err));
    } finally {
      if (yield cancelled()) {
        console.log('cancelled');
      }
    }

    return action;
  }

  function* businessInfoFlow() {
    yield takeLatest(SET_BUSINESSINFO_TO_DRAFT_START, setBusinessInfoToDraft);
  }
}
